import { createReducer } from 'redux-act';
import { PaneIndex } from '@helpers/horizontalPaneState';
import { setLastInfoPane, setLastNotesPane } from './ui.actions';

export interface IUiState {
  lastInfoPane: PaneIndex;
  lastNotesPane: PaneIndex;
}

const defaultState:IUiState = {
  lastInfoPane: 0,
  lastNotesPane: 0,
};

const reducer = createReducer<IUiState>({}, defaultState);

reducer
  .on(setLastInfoPane, (state, payload) => ({
    ...state,
    lastInfoPane: payload,
  }))
  .on(setLastNotesPane, (state, payload) => ({
    ...state,
    lastNotesPane: payload,
  }));

export default reducer;



// WEBPACK FOOTER //
// ./src/services/ui/ui.reducer.ts